/**
 * MacroIcon — one of the four macro glyphs (קלוריות / פחמימות / חלבון / שומן),
 * drawn in pure CSS (see MacroIcon.css for why). Decorative: the label next
 * to it carries the meaning, so the span is hidden from assistive tech.
 *
 * `size` is optional — omit it to inherit the stylesheet default (14px) or
 * whatever `--nmb-macro-size` the parent sets.
 */

import "./MacroIcon.css";

/** Macro key → CSS modifier. Anything else renders nothing. */
const MACRO_MODIFIERS = {
  calories: "calories",
  carbohydrates: "carbs",
  protein: "protein",
  fat: "fat",
};

const MacroIcon = ({ macro, size, className = "" }) => {
  const modifier = MACRO_MODIFIERS[macro];
  if (!modifier) return null;

  const style = size ? { "--nmb-macro-size": `${size}px` } : undefined;

  return (
    <span
      className={`nmb-macro-icon nmb-macro-icon--${modifier} ${className}`.trim()}
      style={style}
      aria-hidden="true"
    />
  );
};

export default MacroIcon;
